import { gql } from "@apollo/client";

export default gql`
  query GroupMembers($slug: String!, $cursor: Cursor, $search: String) {
    groupBySlug(slug: $slug) {
      _id
      members(cursor: $cursor, search: $search) {
        items {
          ... on PendingUser {
            _id
            slug
            firstName
            fullName
            avatar
            jobTitle
            createdAt
          }
          ... on GovernmentUser {
            _id
            slug
            firstName
            jobTitle
            fullName
            avatar
            title
            createdAt
          }
          ... on VendorUser {
            _id
            slug
            firstName
            jobTitle
            fullName
            avatar
            title
            createdAt
          }
        }
        pageInfo {
          endCursor
          hasNextPage
        }
      }
    }
  }
`;
